import React from 'react';
import { Dropdown, Bubble } from 'tea-component';
import classNames from 'classnames';
import { CUSTOM_VALUE } from '../../config';
import EventCountInput from '@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/components/EventFilterContent/components/EventCountInput';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import './index.scss';
import CommonBubble from '@home/components/CommonBubble';

interface IHoursSinceRegisterSelectProps {
  value: string;
  customValue: string;
  onChange: (val: string) => void;
  onCustomChange: (val: string) => void;
  options: { value: string; text: string; }[];
  placeholder: string;
}

const HoursSinceRegisterSelect: React.FC<IHoursSinceRegisterSelectProps> = ({
  value,
  customValue,
  onChange,
  onCustomChange,
  options,
  placeholder,
}) => {
  const { getLocalText } = useLocal('filter');
  const isCustomHours = value === CUSTOM_VALUE;
  const hoursMaxExceeded = isCustomHours && customValue !== '' && Number(customValue) > 168;

  const displayText = isCustomHours
    ? (customValue || placeholder)
    : (options.find(o => o.value === value)?.text || placeholder);

  const content = (
    <div className="dbd-event-filter-content__hours-select dbd-event-filter-content__hours-select--bubble">
      <Dropdown
        clickClose={true}
        appearance="button"
        overlayClassName={'dbd-event-filter-content__hours-overlay'}
        button={(
          <div className="selector-multiple__header select-button" style={{ width: '100%' }}>
            <span className={classNames("dbd-select-button-value", {
              "dbd-select-button-value--placeholder": Number.isNaN(Number(value || CUSTOM_VALUE)) && Number.isNaN(Number(customValue || CUSTOM_VALUE))
            })}>
              {displayText}
            </span>
          </div>
        )}
      >
        <div className="dbd-event-filter-content__hours-menu">
          <ul className="dbd-event-filter-content__hours-list">
            {options.map(option => (
              <li
                key={option.value}
                className={classNames('dbd-event-filter-content__hours-item', {
                  'dbd-event-filter-content__hours-item--active': value === option.value
                })}
                onClick={() => onChange(option.value)}
              >
                {option.text}
              </li>
            ))}
            <li
              className={classNames('dbd-event-filter-content__hours-item dbd-event-filter-content__hours-item--custom', {
                'dbd-event-filter-content__hours-item--active': isCustomHours
              })}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="dbd-event-filter-content__hours-item-label">{getLocalText('custom')}</span>
              <div className="dbd-event-filter-content__hours-item-input" onClick={e => e.stopPropagation()}>
                <EventCountInput
                  value={customValue || ''}
                  onChange={onCustomChange}
                  max={168}
                />
              </div>
            </li>
          </ul>
        </div>
      </Dropdown>
    </div>
  );

  return (
    <CommonBubble
      visible={hoursMaxExceeded}
      placement="top"
      error
      transitionTimeout={0}
      content={<span className="dbd-event-count-input__error-text">{getLocalText('hours_max_exceeded')}</span>}
    >
      {content}
    </CommonBubble>
  );
};

export default HoursSinceRegisterSelect;
